import {
  Icon,
  ICONS_ENUM,
  TableCell,
  TableRow,
  Tooltip,
  Typography
} from '@sanlam-glacier/app-common/components';
import styles from './internal-rate-of-return.module.scss';
import { InternalRateOfReturn } from 'modules/clients/types/transaction-summary';

const InternalRateOfReturnRow = ({
  internalRateOfReturn,
  tooltipContent,
  specifiedPeriod,
  oneYear,
  threeYears,
  fiveYears,
  testid
}: InternalRateOfReturn) => {
  function formatPercentage(num: number): string {
    const truncated = Math.trunc(num * 100) / 100;
    return truncated.toFixed(2);
  }

  return (
    <TableRow key={internalRateOfReturn} className={styles.row}>
      <TableCell align={TableCell.ALIGN.LEFT} className={styles.descriptionCell}>
        <Typography
          data-testid={`${testid}Description`}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {internalRateOfReturn}
        </Typography>
        <Tooltip
          data-testid={`${testid}Tooltip`}
          content={tooltipContent}
          className={styles.tooltip}
          position={Tooltip.POSITION.RIGHT}
        >
          <span>
            <Icon icon={ICONS_ENUM.ACTION_INFO_OUTLINE} className={styles.tooltipIcon} />
          </span>
        </Tooltip>
      </TableCell>
      <TableCell />
      <TableCell align={TableCell.ALIGN.RIGHT} className={styles.cell}>
        <Typography
          data-testid={`${testid}SpecifiedPeriod`}
          className={styles.periodText}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {formatPercentage(Number(specifiedPeriod))}%
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.RIGHT} className={styles.cell}>
        <Typography
          data-testid={`${testid}OneYearValue`}
          className={styles.periodText}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {formatPercentage(Number(oneYear))}%
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.RIGHT} className={styles.cell}>
        <Typography
          data-testid={`${testid}ThreeYearValue`}
          className={styles.periodText}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {formatPercentage(Number(threeYears))}%
        </Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.RIGHT} className={styles.cell}>
        <Typography
          data-testid={`${testid}FiveYearsValue`}
          className={styles.periodText}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B4}
        >
          {formatPercentage(Number(fiveYears))}%
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default InternalRateOfReturnRow;
